import { Image, PrismicImage } from './Image';

export const transformToImage = (
    imageResource: PrismicImage,
): Image => ({
    src: imageResource.url,
    alt: imageResource.alt,
});
